<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pUYR7b/Images/cover00269.jpeg?1693479751709" alt="This image is the cover for the book Failure of Justice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Failure of Justice
      </h1>
      <p class="bookDescription body article font2">
        <b>“A chilling piece of journalism” from the bestselling author of <i>Wrecking Crew: Demolishing the Case Against Steven Avery </i>(Ron Franscell , author of <i>Alice &amp; Gerald</i>).</b><br/><br/> In this thrilling true crime book, bestselling and award-winning author John Ferak explores the murder, investigation, trial, conviction and eventual exoneration—the largest such ever in the United States—of the Beatrice 6. <br/>  <br/> On February 5, 1985, one of the coldest nights on record, Beatrice, Nebraska widow Helen Wilson was murdered inside her second-floor apartment. The news of six arrests was absolutely stunning to the locals in this easy-going, blue-collar community of 12,000 residents. But why were six loosely connected misfits who lived as far away as Alabama, Colorado and North Carolina being linked to the rape and murder of a beloved small-town widow? <br/><br/> After all six of the condemned were convicted of murder and sent away to prison for the ghastly crime, the town moved on, convinced that justice was served. For more than twenty-five years, the Beatrice 6 rotted in prison, until the unthinkable occurred in 2008 . . .  <br/>  <br/> In <i>Failure of Justice</i>, John Ferak delivers a “riveting account . . . [of] an overzealous police investigation that generated false confessions and false evidence. The unbelievable story of the Beatrice 6 provides a wake-up call at a time when serious wrongful convictions continue to come to light with disturbing frequency” (Brandon L. Garrett, Justice Thurgood Marshall Distinguished Professor of Law, University of Virginia School of Law).<br/>  <br/> “One of the most bizarre stories I’ve ever heard of.”—Burl Barer, Edgar Award-winning true-crime author, host of Outlaw radio’s <i>True Crime Uncensored</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Ferak
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?47fa1fef